import { Card, CardContent } from '../../../components/ui/card';
import { Check, RefreshCw } from 'lucide-react';
import { DuplicateCard } from './DuplicateCard';
import { AutoMergeBanner } from './AutoMergeBanner';
import { BulkRestoreBanner } from './BulkRestoreBanner';

export const ParentDuplicatesTab = ({ loading, duplicates, onMerge, onIgnore, ignoring, onAutoMergeApplied }) => {
  return (
    <>
      <BulkRestoreBanner onRestored={onAutoMergeApplied} />
      {!loading && duplicates.length > 0 && (
        <AutoMergeBanner onApplied={onAutoMergeApplied} />
      )}
      {loading ? (
        <div className="text-center py-8">
          <RefreshCw className="h-8 w-8 animate-spin mx-auto text-slate-400" />
          <p className="text-slate-500 mt-2">Scanning for duplicates...</p>
        </div>
      ) : duplicates.length === 0 ? (
        <Card>
          <CardContent className="text-center py-8">
            <Check className="h-12 w-12 mx-auto text-green-500 mb-3" />
            <p className="text-lg font-medium text-green-700">No duplicate accounts found</p>
            <p className="text-slate-500">All parent &amp; customer records appear to be unique.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-4">
          {duplicates.map((dup, idx) => {
            try {
              return (
                <DuplicateCard
                  key={dup?.parent1?.id || idx}
                  type="parent"
                  dup={dup}
                  onMerge={onMerge}
                  onIgnore={onIgnore}
                  ignoring={ignoring}
                />
              );
            } catch (e) {
              console.error('Error rendering parent duplicate card:', e, dup);
              return (
                <Card key={idx} className="border-red-200 bg-red-50">
                  <CardContent className="p-4 text-red-600">
                    Error rendering duplicate record. Please try refreshing.
                  </CardContent>
                </Card>
              );
            }
          })}
        </div>
      )}
    </>
  );
};
